import * as Toast from "vue-toastification";

const { useToast: useVueToastificationToast } = Toast;

export const useToast = () => {
  return useVueToastificationToast();
};

// Use this composable to completely disable toast messages, for example when a dialog is open
export const useDisableToast = () => {
  const toast = useToast();
  onBeforeMount(() => {
    toast.updateDefaults({
      filterBeforeCreate: () => false,
    });
  });

  onBeforeUnmount(() => {
    toast.updateDefaults({
      filterBeforeCreate: (toast) => toast,
    });
  });
};
